import { z } from 'zod';
import http from '@/lib/http';
import {
  CreateDriverGroupDto,
  DriverGroupDto,
  DriverGroupDtoSchema,
  SuccessResponse,
  SuccessResponseSchema,
  UpdateDriverGroupDto,
} from '@cargovibe/shared-types';

export const getDriverGroups = async (): Promise<DriverGroupDto[]> => {
  return http.get<DriverGroupDto[]>('/driver-groups', z.array(DriverGroupDtoSchema));
};

export const createDriverGroup = async (data: CreateDriverGroupDto): Promise<DriverGroupDto> => {
  return http.post<DriverGroupDto>('/driver-groups', DriverGroupDtoSchema, data);
};

export const updateDriverGroup = async (
  groupId: string,
  data: UpdateDriverGroupDto
): Promise<DriverGroupDto> => {
  return http.patch<DriverGroupDto>(
    `/driver-groups/${encodeURIComponent(groupId)}`,
    DriverGroupDtoSchema,
    data
  );
};

export const deleteDriverGroup = async (groupId: string): Promise<SuccessResponse> => {
  return http.delete<SuccessResponse>(
    `/driver-groups/${encodeURIComponent(groupId)}`,
    SuccessResponseSchema
  );
};
